__turbopack_context__.v({
  "signModalBody": "Auth-module-scss-module__gz2Ngq__signModalBody",
  "signModalButtonContent": "Auth-module-scss-module__gz2Ngq__signModalButtonContent",
  "signModalCancelButton": "Auth-module-scss-module__gz2Ngq__signModalCancelButton",
  "signModalConfirmButton": "Auth-module-scss-module__gz2Ngq__signModalConfirmButton",
  "signModalDialog": "Auth-module-scss-module__gz2Ngq__signModalDialog",
  "signModalFooter": "Auth-module-scss-module__gz2Ngq__signModalFooter",
  "signModalHeader": "Auth-module-scss-module__gz2Ngq__signModalHeader",
  "signModalLead": "Auth-module-scss-module__gz2Ngq__signModalLead",
  "signModalList": "Auth-module-scss-module__gz2Ngq__signModalList",
  "signModalSurface": "Auth-module-scss-module__gz2Ngq__signModalSurface",
  "signModalTitle": "Auth-module-scss-module__gz2Ngq__signModalTitle",
});
